import { useQuery } from 'react-query';
import {
  UseSignaturePaymentProspectOptions,
  UseSignaturePaymentProspectParams,
  UseSignaturePaymentProspectResponse,
} from './useSignaturePaymentProspect.types';
import { querySignaturePaymentProspect } from './useSignaturePaymentProspect.query';

export const SIGNATURE_PAYMENT_PROSPECT_QUERY_KEY = 'SIGNATURE_PAYMENT_PROSPECT';

export const useSignaturePaymentProspect = (
  params: UseSignaturePaymentProspectParams,
  options?: UseSignaturePaymentProspectOptions
) => {
  return useQuery<UseSignaturePaymentProspectResponse, Error>(
    SIGNATURE_PAYMENT_PROSPECT_QUERY_KEY,
    () => querySignaturePaymentProspect(params),
    {
      ...options,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
};
